import { authorizedInstance } from "../config/axios"

export const summarize = async ({ prompt, model, text }) => {
  const response = await authorizedInstance.post("/ai/summarize", {
    prompt,
    model,
    text,
  })
  return response.data
}

export const structuredOutput = async ({ model, prompt, text, schema }) => {
  const requestBody = {
    model,
    prompt,
    text,
    schema,
  }

  const response = await authorizedInstance.post(
    "/ai/call-structured-output",
    requestBody
  )
  return { text: JSON.stringify(response.data.completion.final_answer) }
}
